import ModalEl from 'react-modal'
import { PropsWithChildren } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

if (process.env.NODE_ENV !== 'test') ModalEl.setAppElement('#root')

type DialogProps = PropsWithChildren<
	WithClassName<{
		isOpened: boolean
		ariaLabel: string
		closeModal: () => void
		onAfterOpen?: () => void
	}>
>

export const Dialog = ({
	children,
	className,
	isOpened,
	ariaLabel,
	closeModal,
	onAfterOpen
}: DialogProps) => (
	<ModalEl
		isOpen={isOpened}
		onRequestClose={closeModal}
		onAfterOpen={onAfterOpen}
		contentLabel={ariaLabel}
		ariaHideApp={process.env.NODE_ENV !== 'test'}
		overlayClassName="fixed inset-0 z-[1000] grid place-items-center bg-overlay p-4"
		className={cn(
			'relative flex max-h-[85vh] w-full max-w-lg flex-col overflow-hidden rounded-lg border border-border bg-card shadow-panel outline-none',
			className
		)}>
		{children}
	</ModalEl>
)
